import { Provider } from "@rollbar/react";
import { PropsWithChildren } from "react";
import { rollbarConfig } from "./rollbar.config";

export function RollbarProvider({ children }: PropsWithChildren<{}>) {
	return <Provider config={rollbarConfig}>{children}</Provider>;
}
